import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import Home from "@/pages/Home";
import { Toaster } from "@/components/ui/sonner";

function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handler = () => setReduced(mq.matches);
    handler();
    mq.addEventListener?.("change", handler);
    return () => mq.removeEventListener?.("change", handler);
  }, []);
  return reduced;
}

function LenisWrap({ children, enabled }) {
  useEffect(() => {
    if (!enabled) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 0.9,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [enabled]);
  return children;
}

function App() {
  const reduced = usePrefersReducedMotion();
  return (
    <div className="App grain min-h-screen bg-[#0A0A0A] text-white">
      <MotionConfig reducedMotion={reduced ? "always" : "never"}>
        <BrowserRouter>
          <LenisWrap enabled={!reduced}>
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
          </LenisWrap>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </MotionConfig>
    </div>
  );
}

export default App;
